"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConventionalAssetFields = void 0;
var entities_1 = require("@common/entities");
var COMMON_ADDRESS_FIELDS_1 = require("../COMMON_ADDRESS_FIELDS");
var getConventionalAssetFields = function (assetType, customType) {
    if (customType === void 0) { customType = entities_1.AssetTypes.CheckingAccount; }
    switch (customType) {
        case entities_1.AssetTypes.CheckingAccount:
        case entities_1.AssetTypes.SavingsAccount:
        case entities_1.AssetTypes.CertificateOfDeposit:
        case entities_1.AssetTypes.StocksOrBonds:
        case entities_1.AssetTypes.RetirementAccount:
            return __spreadArray(__spreadArray([
                {
                    customType: entities_1.FieldType.Text,
                    enabled: true,
                    label: 'Institution Name',
                    name: entities_1.IncomeFields.institutionName.name,
                    required: true,
                    sequence: 1,
                    type: entities_1.FieldType.Text,
                },
                {
                    customType: entities_1.FieldType.Text,
                    enabled: true,
                    label: 'Name on the Account',
                    name: entities_1.AssetFields.nameOnAccount.name,
                    required: true,
                    sequence: 2,
                    type: entities_1.FieldType.Text,
                }
            ], (0, COMMON_ADDRESS_FIELDS_1.getCommonAddressFields)(3), true), [
                {
                    customType: entities_1.FieldType.Number,
                    enabled: true,
                    label: 'Routing Number',
                    name: entities_1.AssetFields.routingNumber.name,
                    required: true,
                    sequence: 10,
                    type: entities_1.FieldType.Number,
                },
                {
                    customType: entities_1.FieldType.Number,
                    enabled: true,
                    label: 'Account Number',
                    name: entities_1.AssetFields.accountNumber.name,
                    required: true,
                    sequence: 11,
                    type: entities_1.FieldType.Number,
                },
                {
                    customType: entities_1.FieldType.Text,
                    enabled: true,
                    label: 'Contact Name',
                    name: entities_1.IncomeFields.contactName.name,
                    required: true,
                    sequence: 12,
                    type: entities_1.FieldType.Text,
                },
                {
                    customType: entities_1.FieldType.PhoneNumber,
                    enabled: true,
                    label: 'Contact Phone',
                    name: entities_1.IncomeFields.contactPhone.name,
                    required: true,
                    sequence: 13,
                    type: entities_1.FieldType.PhoneNumber,
                },
                {
                    customType: entities_1.FieldType.PhoneNumber,
                    enabled: true,
                    label: 'Contact Fax',
                    name: entities_1.IncomeFields.contactFax.name,
                    required: true,
                    sequence: 14,
                    type: entities_1.FieldType.PhoneNumber,
                },
                {
                    customType: entities_1.FieldType.Email,
                    enabled: true,
                    label: 'Contact Email',
                    name: entities_1.IncomeFields.contactEmail.name,
                    required: true,
                    sequence: 15,
                    type: entities_1.FieldType.Email,
                },
                {
                    customType: entities_1.FieldType.File,
                    enabled: true,
                    label: 'Upload Proof of Assets',
                    name: "applicant_".concat(assetType, "_asset_document_upload"),
                    required: true,
                    sequence: 16,
                    type: entities_1.FieldType.File,
                },
            ], false);
        case entities_1.AssetTypes.MutualFunds:
        case entities_1.AssetTypes.TrustAccounts:
        case entities_1.AssetTypes.CashOnHand:
        case entities_1.AssetTypes.LifeInsurance:
            return __spreadArray(__spreadArray([
                {
                    customType: entities_1.FieldType.Text,
                    enabled: true,
                    label: 'Institution Name',
                    name: entities_1.IncomeFields.institutionName.name,
                    required: true,
                    sequence: 1,
                    type: entities_1.FieldType.Text,
                },
                {
                    customType: entities_1.FieldType.Amount,
                    enabled: true,
                    label: 'Market Value',
                    name: entities_1.AssetFields.marketValue.name,
                    required: true,
                    sequence: 2,
                    type: entities_1.FieldType.Amount,
                },
                {
                    customType: entities_1.FieldType.Text,
                    enabled: true,
                    label: 'Name on the Account',
                    name: entities_1.AssetFields.nameOnAccount.name,
                    required: true,
                    sequence: 3,
                    type: entities_1.FieldType.Text,
                }
            ], (0, COMMON_ADDRESS_FIELDS_1.getCommonAddressFields)(4), true), [
                {
                    customType: entities_1.FieldType.Text,
                    enabled: true,
                    label: 'Contact Name',
                    name: entities_1.IncomeFields.contactName.name,
                    required: true,
                    sequence: 11,
                    type: entities_1.FieldType.Text,
                },
                {
                    customType: entities_1.FieldType.PhoneNumber,
                    enabled: true,
                    label: 'Contact Phone',
                    name: entities_1.IncomeFields.contactPhone.name,
                    required: true,
                    sequence: 12,
                    type: entities_1.FieldType.PhoneNumber,
                },
                {
                    customType: entities_1.FieldType.PhoneNumber,
                    enabled: true,
                    label: 'Contact Fax',
                    name: entities_1.IncomeFields.contactFax.name,
                    required: true,
                    sequence: 13,
                    type: entities_1.FieldType.PhoneNumber,
                },
                {
                    customType: entities_1.FieldType.Email,
                    enabled: true,
                    label: 'Contact Email',
                    name: entities_1.IncomeFields.contactEmail.name,
                    required: true,
                    sequence: 14,
                    type: entities_1.FieldType.Email,
                },
            ], false);
        case entities_1.AssetTypes.PropertyAsInvestment:
        case entities_1.AssetTypes.RealEstateSale:
        case entities_1.AssetTypes.RealEstateRent:
        case entities_1.AssetTypes.RealEstateEquity:
        case entities_1.AssetTypes.OtherAssets:
            return __spreadArray(__spreadArray([
                {
                    customType: entities_1.FieldType.Amount,
                    enabled: true,
                    label: 'Market Value',
                    name: entities_1.AssetFields.marketValue.name,
                    required: true,
                    sequence: 1,
                    type: entities_1.FieldType.Amount,
                },
                {
                    customType: entities_1.FieldType.Text,
                    enabled: true,
                    label: 'Name on the Account',
                    name: entities_1.AssetFields.nameOnAccount.name,
                    required: true,
                    sequence: 2,
                    type: entities_1.FieldType.Text,
                }
            ], (0, COMMON_ADDRESS_FIELDS_1.getCommonAddressFields)(3), true), [
                {
                    customType: entities_1.FieldType.Text,
                    enabled: true,
                    label: 'Contact Name',
                    name: entities_1.IncomeFields.contactName.name,
                    required: true,
                    sequence: 10,
                    type: entities_1.FieldType.Text,
                },
                {
                    customType: entities_1.FieldType.PhoneNumber,
                    enabled: true,
                    label: 'Contact Phone',
                    name: entities_1.IncomeFields.contactPhone.name,
                    required: true,
                    sequence: 11,
                    type: entities_1.FieldType.PhoneNumber,
                },
                {
                    customType: entities_1.FieldType.PhoneNumber,
                    enabled: true,
                    label: 'Contact Fax',
                    name: entities_1.IncomeFields.contactFax.name,
                    required: true,
                    sequence: 12,
                    type: entities_1.FieldType.PhoneNumber,
                },
                {
                    customType: entities_1.FieldType.Email,
                    enabled: true,
                    label: 'Contact Email',
                    name: entities_1.IncomeFields.contactEmail.name,
                    required: true,
                    sequence: 13,
                    type: entities_1.FieldType.Email,
                },
                {
                    customType: entities_1.FieldType.File,
                    enabled: true,
                    label: 'Upload Proof of Assets',
                    name: "applicant_".concat(assetType, "_asset_document_upload"),
                    required: true,
                    sequence: 14,
                    type: entities_1.FieldType.File,
                },
            ], false);
        default:
            return [];
    }
    return;
};
exports.getConventionalAssetFields = getConventionalAssetFields;
